import { css } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@utils/theme";

export const StyleCardHeader = styled.div<any>`
  background-color: #fff4f4;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  padding: 14px 12px;
  color: ${theme.colors.primary};
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 5px;
  ${(props) =>
    props.$justifyAround &&
    css`
      justify-content: space-between;
    `}

  ${(props: any) => props.stylecardheader}
`;
